(function() {
  var isChallengePage = window.location.pathname.indexOf('/challenge') !== -1;

  if (isChallengePage) {
    if (window.location.hash) {
      history.replaceState(null, '', window.location.pathname + window.location.search);
      window.scrollTo(0, 0);
    }
    return;
  }

  document.addEventListener('DOMContentLoaded', function() {
    const toggles = document.querySelectorAll('.tk-footer__column-toggle');

    toggles.forEach(toggle => {
      toggle.addEventListener('click', function() {
        const expanded = this.getAttribute('aria-expanded') === 'true';
        this.setAttribute('aria-expanded', !expanded);
        this.closest('.tk-footer__link-column').classList.toggle('is-open');
      });
    });

    const countrySelect = document.getElementById('footer-country-select');
    if (countrySelect) {
      countrySelect.addEventListener('change', function() {
        this.closest('form').submit();
      });
    }

    const languageSelect = document.getElementById('footer-language-select');
    if (languageSelect) {
      languageSelect.addEventListener('change', function() {
        this.closest('form').submit();
      });
    }

    var newsletterForm = document.querySelector('.js-newsletter-form');
    if (newsletterForm) {
      newsletterForm.addEventListener('submit', function() {
        sessionStorage.setItem('scrollToNewsletter', 'true');
      });
    }

    var urlParams = new URLSearchParams(window.location.search);
    var hasPosted = urlParams.get('customer_posted') === 'true';

    if (hasPosted) {
      sessionStorage.removeItem('scrollToNewsletter');

      if (window.location.hash) {
        history.replaceState(null, '', window.location.pathname + window.location.search);
      }

      window.addEventListener('load', function() {
        setTimeout(function() {
          var successMessage = document.querySelector('.tk-footer__newsletter-success');
          var newsletter = document.getElementById('tk-newsletter-section');
          var isMobile = window.innerWidth < 750;

          if (successMessage && isMobile) {
            successMessage.scrollIntoView({ behavior: 'instant', block: 'center' });
          } else if (newsletter) {
            newsletter.scrollIntoView({ behavior: 'instant', block: 'center' });
          }
        }, 150);
      });
    }
  });
})();
